import { baseApi } from "./baseApi";

// Brands API
export const dealerMappingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDealerMappings: builder.query({
      query: (params) => {
        let url = "third_party_dealer_mappings";

        url += "?";

        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }
        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }
        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.dealer_name) {
          url += `dealer_name=${params.dealer_name}&`;
        }
        if (params.dealer_code) {
          url += `dealer_code=${params.dealer_code}&`;
        }
        if (params.assigned_city_manager_id) {
          url += `assigned_city_manager_id=${params.assigned_city_manager_id}&`;
        }
        if (params.city_id) {
          url += `branch_city_id=${params.city_id}&`;
        }
        if (params.state_id) {
          url += `branch_state_id=${params.state_id}&`;
        }
        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    getDealerMapping: builder.query({
      query: (id) => `third_party_dealer_mappings/${id}`
    }),
    createDealerMapping: builder.mutation({
      query: (params) => ({
        url: "third_party_dealer_mappings",
        method: "POST",
        body: params.dealerMappingData
      })
    }),
    updateDealerMapping: builder.mutation({
      query: (params) => ({
        url: `third_party_dealer_mappings/${params.id}`,
        method: "PUT",
        body: params.dealerMappingData
      })
    }),
    deleteDealerMapping: builder.mutation({
      query: (params) => ({
        url: `third_party_dealer_mappings/${params.id}`,
        method: "Delete",
        body: params.id
      })
    })
  })
});

// Export mutations and queries
export const {
  useGetDealerMappingsQuery,
  useGetDealerMappingQuery,
  useCreateDealerMappingMutation,
  useUpdateDealerMappingMutation,
  useDeleteDealerMappingMutation
} = dealerMappingApi;
